<!-- Header de página -->
<div class="page-header">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <h1 class="page-title">LIQUIDACIONES VD</h1>
            <p class="page-subtitle text-muted">
                Gestión y consulta de liquidaciones VD
            </p>
        </div>
        <div class="header-actions">
            <button 
                mat-raised-button 
                color="accent" 
                (click)="exportarExcel()" 
                [disabled]="isLoading || isGeneratingExcel"
                matTooltip="Exportar datos actuales a Excel">
                <mat-icon>download</mat-icon>
                Excel
            </button>
        </div>
    </div>
</div>

<!-- Filtros de búsqueda -->
<mat-card class="filters-card">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>filter_list</mat-icon>
            Filtros de Búsqueda
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="filters-section">
            <div class="filters-grid filters-grid-50">
                <!-- Campo para usuarios con rol cliente (input deshabilitado) -->
                <mat-form-field *ngIf="isClienteRole" appearance="outline" class="filter-field">
                    <mat-label>Cliente</mat-label>
                    <input matInput 
                           [formControl]="clienteControl"
                           placeholder="Cliente asignado"
                           readonly
                           inputmode="text">
                    <mat-icon matSuffix color="primary">person</mat-icon>
                </mat-form-field>
                
                <!-- Campo para otros roles (autocomplete habilitado) -->
                <mat-form-field *ngIf="!isClienteRole" appearance="outline" class="filter-field">
                    <mat-label>Cliente</mat-label>
                    <input matInput 
                           [formControl]="clienteControl"
                           [matAutocomplete]="autoCliente" 
                           placeholder="Buscar cliente..."
                           inputmode="text">
                    <mat-autocomplete #autoCliente="matAutocomplete" 
                                      [displayWith]="mostrarCliente"
                                      (optionSelected)="onClienteSeleccionado($event.option.value)">
                        <mat-option *ngIf="isLoadingClientes" class="loading-option" disabled>
                            <i class="ri-loader-4-line animate-spin me-2"></i>
                            Cargando clientes...
                        </mat-option>
                        <mat-option *ngFor="let cliente of clientesFiltrados | async" [value]="cliente">
                            {{ cliente.cliente }}
                        </mat-option>
                        <mat-option *ngIf="!isLoadingClientes && (clientesFiltrados | async)?.length === 0" disabled>
                            No se encontraron clientes
                        </mat-option>
                    </mat-autocomplete>
                    <button *ngIf="clienteSeleccionado" 
                            mat-icon-button 
                            matSuffix 
                            (click)="limpiarCliente()" 
                            type="button"
                            matTooltip="Limpiar cliente">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <mat-icon *ngIf="!clienteSeleccionado" matSuffix>search</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Temporada</mat-label>
                    <mat-select [(ngModel)]="filtroTemporada" [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="null">Todas las temporadas</mat-option>
                        <mat-option *ngFor="let temporada of temporadasDisplayOptions" [value]="temporada.value">
                            {{temporada.label}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>calendar_today</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Fecha de Inicio</mat-label>
                    <input matInput 
                           [matDatepicker]="pickerInicio" 
                           [(ngModel)]="filtroFechaInicio" [ngModelOptions]="{standalone: true}"
                           placeholder="Seleccionar fecha de inicio"
                           inputmode="none">
                    <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                    <mat-datepicker #pickerInicio></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Fecha de Fin</mat-label>
                    <input matInput 
                           [matDatepicker]="pickerFin" 
                           [(ngModel)]="filtroFechaFin" [ngModelOptions]="{standalone: true}"
                           placeholder="Seleccionar fecha de fin"
                           inputmode="none">
                    <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                    <mat-datepicker #pickerFin></mat-datepicker>
                </mat-form-field>
            </div>

            <!-- Botones de acción -->
            <div class="filter-actions">
                <button 
                    mat-raised-button 
                    color="primary" 
                    (click)="aplicarFiltros()"
                    [disabled]="isLoading"
                    matTooltip="Buscar con los filtros aplicados">
                    <mat-icon>search</mat-icon>
                    Buscar
                </button>
                <button 
                    mat-raised-button 
                    color="warn" 
                    (click)="limpiarFiltros()"
                    [disabled]="isLoading"
                    matTooltip="Limpiar todos los filtros">
                    <mat-icon>clear</mat-icon>
                    Limpiar
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<!-- Tabla de datos -->
<mat-card class="data-card">
    <mat-card-content>
        <!-- Estado de carga -->
        <div class="loading-container" *ngIf="isLoading">
            <div class="loading-spinner">
                <i class="ri-loader-4-line"></i>
                <p>{{loadingMessage}}</p>
            </div>
        </div>

        <div class="liquidaciones-list-table" *ngIf="!isLoading">
            <div class="table-responsive">
                <table mat-table [dataSource]="filteredDataSource" matSort (matSortChange)="onSortChange($event)">

                    <!-- N° Liquidación Column -->
                    <ng-container matColumnDef="numeroLiquidacion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-0">
                            N° Liq.
                        </th>
                        <td mat-cell *matCellDef="let element" class="pl-0">
                            {{element.numeroLiquidacion}}
                        </td>
                    </ng-container>

                    <!-- Mes/Año Column -->
                    <ng-container matColumnDef="mesAnio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Mes/Año
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{formatearMesAnio(element.mesAnio)}}
                        </td>
                    </ng-container>

                    <!-- Cliente Column -->
                    <ng-container matColumnDef="cliente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Cliente
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.cliente}}
                        </td>
                    </ng-container>

                    <!-- Estado Column -->
                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Estado
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="trinta-badge fw-medium d-inline-block" *ngIf="element.estado === 'PENDIENTE'">
                                Pendiente
                            </span>
                            <span class="trinta-badge fw-medium onHand d-inline-block" *ngIf="element.estado === 'APROBADA'">
                                Aprobada
                            </span>
                            <span class="trinta-badge fw-medium urgent d-inline-block" *ngIf="element.estado === 'RECHAZADA'">
                                Rechazada
                            </span>
                            <span class="trinta-badge fw-medium primary d-inline-block" *ngIf="element.estado === 'PAGADA'">
                                Pagada
                            </span>
                            <!-- Estado default para valores que no coinciden exactamente -->
                            <span class="trinta-badge fw-medium d-inline-block" 
                                  *ngIf="element.estado && element.estado !== 'PENDIENTE' && element.estado !== 'APROBADA' && element.estado !== 'RECHAZADA' && element.estado !== 'PAGADA'">
                                {{element.estado}}
                            </span>
                        </td>
                    </ng-container>

                    <!-- CNTR Column -->
                    <ng-container matColumnDef="cntr">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
                            CNTR
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="cantidad-cntr">{{formatearNumero(element.cntr)}}</span>
                        </td>
                    </ng-container>

                    <!-- VD Column -->
                    <ng-container matColumnDef="vd">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
                            VD
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="monto-vd">{{formatearMoneda(element.vd)}}</span>
                        </td>
                    </ng-container>

                    <!-- Total Column -->
                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
                            Total
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="monto-total">{{formatearMoneda(element.total)}}</span>
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef class="text-end pr-0"></th>
                        <td mat-cell *matCellDef="let element" class="text-end pr-0">
                            <div class="action">
                                <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" 
                                        (click)="verDetalle(element)"
                                        matTooltip="Ver Detalle">
                                    <i class="ri-eye-line"></i>
                                </button>
                                <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" 
                                        (click)="generarExcel(element)"
                                        matTooltip="Generar Excel">
                                    <i class="ri-file-excel-2-line"></i>
                                </button>
                                <button type="button" mat-button class="p-0 min-w-auto lh-1 h-auto" 
                                        (click)="generarPdfVd(element)"
                                        matTooltip="Generar PDF">
                                    <i class="ri-file-pdf-line"></i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Fila de totales usando mat-footer-row -->
                    <ng-container matColumnDef="totales-numeroLiquidacion">
                        <td mat-footer-cell *matFooterCellDef class="pl-0 totales-cell-sin-estilo">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-mesAnio">
                        <td mat-footer-cell *matFooterCellDef class="totales-cell-sin-estilo">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-cliente">
                        <td mat-footer-cell *matFooterCellDef class="totales-cell-sin-estilo">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-estado">
                        <td mat-footer-cell *matFooterCellDef class="totales-cell-sin-estilo">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-cntr">
                        <td mat-footer-cell *matFooterCellDef class="totales-cell text-end">
                            <strong class="cantidad-cntr">{{formatearNumero(totales.cntr)}}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-vd">
                        <td mat-footer-cell *matFooterCellDef class="totales-cell text-end">
                            <strong class="monto-vd">{{formatearMoneda(totales.vd)}}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-total">
                        <td mat-footer-cell *matFooterCellDef class="totales-cell text-end">
                            <strong class="monto-total">{{formatearMoneda(totales.total)}}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-acciones">
                        <td mat-footer-cell *matFooterCellDef class="text-end pr-0 totales-cell-sin-estilo">
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    
                    <ng-container *ngIf="filteredDataSource.length > 0 && !isLoading">
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsWithTotales" 
                            class="totales-footer-row"></tr>
                    </ng-container>

                </table>
            </div>
            
            <!-- Mensaje cuando no hay datos -->
            <div class="no-data" *ngIf="filteredDataSource.length === 0 && !isLoading">
                <i class="ri-inbox-line"></i>
                <p>No se encontraron liquidaciones VD que coincidan con los filtros aplicados.</p>
            </div>
            
            <mat-paginator 
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                [pageIndex]="currentPage - 1"
                (page)="onPageChange($event)"
                showFirstLastButtons>
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>

<!-- Overlay de carga para generación de Excel -->
<div *ngIf="isGeneratingExcel" class="excel-loading-overlay">
    <div class="excel-loading-content">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="excel-loading-text">Generando Archivo Excel...</p>
    </div>
</div>